import RoutesMap from '../../../route_control/RouteControl'
import { Form, InputGroup, Card, Button } from 'react-bootstrap'
import { SaveButton } from '../../buttons'
import { useFormik } from 'formik'
import { LoginSchema } from './ValidationSchema'
import { ForgetPasswordSchema } from './ValidationSchema'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import { SignInTodo } from '../../../redux/slices/user-login/SignIn'
import { toast } from 'react-toastify'
import { sidebar } from '../../../redux/slices/user-login/Sidebar'
import { KeyRound, UserRound, Calendar, LandPlot } from 'lucide-react'
import Logo from '../../../assets/images/reexoasset.png'
import ButtonLoader from '../../loader/ButtonLoader'
import { SessionManager } from '../../../utils'
import { LuKeyRound, LuUser, LuEye, LuEyeOff } from 'react-icons/lu'
import { LockKeyhole } from 'lucide-react'


export const LoginFormImport = {
    RoutesMap,
    Form,
    InputGroup,
    Card,
    Button,
    SaveButton,
    useFormik,
    LoginSchema,
    ForgetPasswordSchema,
    useNavigate,
    useDispatch,
    SignInTodo,
    toast,
    sidebar,
    KeyRound,
    UserRound,
    Calendar,
    LandPlot,
    Logo,
    ButtonLoader,
    SessionManager,
    LuKeyRound,
    LuUser,
    LuEye,
    LuEyeOff,
    LockKeyhole
}